import _ from "underscore";
// import { store } from "../../../../redux/store";
import { Type } from "../../../../redux/Transaction/helper";

/**
 * From redux List.fields, get the fields that match the type and matchKeyword
 * eg: getMatchedFields('transaction', 'sale_invoice_show')
 * return  [{id: 1, name: 'Field 1', data_type: 'AMOUNT', data_options: null, is_required: false,...}]
 *
 * @requires List.fields in redux - readList
 * @param {String} type - 'transaction' or 'contact'
 * @param {String} transactionType -
 * @returns {Object[]} array of filtered custom fields objects
 */
export function getMatchedFields(
    fields = {},
    type = 'transaction',
    transactionType = Type.sale_invoice,
) {
    // const hasFields = Object.keys(fields).length > 0;
    // const allFields = hasFields ? fields : store.getState().List?.fields;
    const hasFields = Object.keys(fields).length > 0;
    const allFields = hasFields ? fields : {};

    const matchKeyword = `${transactionType}_show`;
    // const fields = yield select(state => state.List?.fields);
    // const matchedFields = _.sortBy(allFields[type].filter(item => item[matchKeyword]), f => f.id);
    const matchedFields = _.sortBy(allFields[type]?.filter(item => item[matchKeyword]), f => f.id);
    // console.log('aaa custom getMatchedFields', {allFields, type, fieldType: allFields[type], matchKeyword, matchedFields});
    return matchedFields;
}
